import {Component} from "@angular/core";
import {Location} from "@angular/common";

@Component({
  selector: "common-location",
  template: `
  <usecase-container title="Location" src="common/location">
    <usecase-content>
      <p>Current Path: {{path}}</p>
      <button (click)="back()">Back</button>
    </usecase-content>
  </usecase-container>
  `,
})
export class LocationComponent {
  private path: string;
  constructor(private location: Location) {
  }

  ngOnInit() {
    this.path = this.location.path();
  }

  back() {
    this.location.back();
  }
}



/** WEBPACK FOOTER **
 ** ./script/common/location/component.ts
 **/